import personal from './personal'
import contact from './contact'
import local from './local'
import group from './group'
import publicContact from './public'
import share from './share'
import favorite from './favorite'

export default {
    personal,
    contact,
    local,
    group,
    publicContact,
    share,
    favorite
}